module.exports = __webpack_public_path__ + "img/icon-block.a19a45e.svg";